var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIncomingContractors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9412_1560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2933 16.5332C29.7467 14.3999 28.0133 12.7732 25.8667 12.3865V11.0265H23.9467V12.3865C21.7867 12.7732 20.0533 14.3865 19.52 16.5332H18.72V18.4532H20.1867C20.28 20.9732 22.36 22.9999 24.9067 22.9999C27.4533 22.9999 29.5333 20.9732 29.6267 18.4532H31.0933V16.5332H30.2933ZM27.7067 18.4532C27.6133 19.9199 26.3867 21.0799 24.9067 21.0799C23.4267 21.0799 22.2 19.9199 22.1067 18.4532H27.7067ZM25.8667 15.4665V14.3465C26.9467 14.6532 27.84 15.4665 28.2667 16.5332H21.5467C21.9733 15.4665 22.8667 14.6532 23.9467 14.3465V15.4665H25.8667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 24.6532H22.8C20.04 24.6532 17.8 26.8932 17.8 29.6532V32.6665H19.8V29.6532C19.8 28.6798 20.2667 27.8265 20.9867 27.2798V32.6665H22.9867V26.6532H26.8V32.6665H28.8V27.2798C29.52 27.8265 29.9867 28.6798 29.9867 29.6532V32.6665H31.9867V29.6532C31.9867 26.8932 29.7467 24.6532 26.9867 24.6532H27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 4.6665H22V2.6665H20V4.6665H12V2.6665H10V4.6665H6C4.90667 4.6665 4 5.57317 4 6.6665V26.6665C4 27.7598 4.90667 28.6665 6 28.6665H15.8V26.6665H6V12.6665H18V10.6665H6V6.6665H10V8.6665H12V6.6665H20V8.6665H22V6.6665H26V9.13317H28V6.6665C28 5.57317 27.1067 4.6665 26 4.6665Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9412_1560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncomingContractors);
export default __webpack_public_path__ + "static/media/ic-incoming-contractors.c5ae301691c75e29c089bad8f1cd38ca.svg";
export { ForwardRef as ReactComponent };